import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';

//Components
import TextField from '../../../../components/TextField/TextField';

//Api
import ramoDeAtividade_api from '../../../../api/ramoDeAtividade_api';
import geradoresCategoria_api from '../../../../api/geradoresCategoria_api';
import gerador_api from '../../../../api/gerador_api';
import cnae_api from '../../../../api/cnae_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//Context
import { useAuth } from '../../../../context/auth';

export default function IdentificacaoGerador({
    gerador, setGerador, errors, setErrors, onChangeGerador, integracaoCadastros, disabledCampos = false }) {
    const { session, setupVariavel } = useAuth();

    //Opções do select de CNAE (principal e secundários)
    const [cnaesOptions, setCnaesOptions] = useState([]);

    //Opções do select de status do gerador
    const statusOptions = [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
    ];

    //Categorias do gerador (alimentadas pela tabela tbGeradoresCategorias)
    const [categorias, setCategorias] = useState([
        { value: "", text: "Selecione" },
    ]);

    //Ramos de atividade do select de ramos de atividade
    const [ramosDeAtividade, setRamosDeAtividade] = useState([
        { value: "", text: "Selecione" },
    ]);

    //carrega as opções de ramos de atividade e prefeituras assim que o componente é inicializado
    useEffect(() => {
        ramoDeAtividade_api.GetList().then(response => {
            const _ramosDeAtividade = response.data.map(value => {
                return { value: value.id, text: value.descricao }
            })
            setRamosDeAtividade([...ramosDeAtividade, ..._ramosDeAtividade]);
        }).catch(e => showMessage("Aviso", e.message, "error", null))

        //Carrega as categorias ativas do gerador a partir da tabela de categorias
        geradoresCategoria_api.GetListAtivos().then(response => {
            const _categorias = response.data.map(value => {
                return { value: value.descricao, text: value.descricao }
            })
            setCategorias([{ value: "", text: "Selecione" }, ..._categorias]);
        }).catch(e => showMessage("Aviso", e.message, "error", null))

    }, []);

    //Carrega os CNAEs ativos apenas quando a prefeitura exibe os campos de CNAE
    useEffect(() => {
        if (!setupVariavel?.informarCnaeCadastroGerador)
            return;

        cnae_api.GetListAtivos().then(response => {
            const _cnaes = response.data.map(value => {
                return { value: value.id, codigo: value.codigo, text: `${value.codigo} - ${value.descricao}`, label: `${value.codigo} - ${value.descricao}` }
            })
            setCnaesOptions(_cnaes);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
    }, [setupVariavel?.informarCnaeCadastroGerador]);

    //Cnae principal selecionado (gerador.cnaes guarda os vínculos, principal e secundários)
    const cnaePrincipal = (gerador.cnaes ?? []).find(c => c.principal);
    const cnaesSecundarios = (gerador.cnaes ?? [])
        .filter(c => !c.principal)
        .map(c => cnaesOptions.find(o => o.value == c.tbCnaes_Id) ?? { value: c.tbCnaes_Id, text: c.codigo, label: c.codigo });

    //Change do CNAE principal
    const onChangeCnaePrincipal = (e) => {
        const { value } = e.target;
        const _id = value ? parseInt(value) : null;
        //Remove o CNAE escolhido dos secundários, pois o mesmo CNAE não pode ser
        //vinculado duas vezes ao gerador
        const _cnaes = (gerador.cnaes ?? []).filter(c => !c.principal && c.tbCnaes_Id != _id);
        if (_id) {
            //Guarda o código junto do vínculo para exibir na revisão do cadastro (Finalizar)
            //antes de salvar, quando ainda não há retorno do backend com o código
            const opcao = cnaesOptions.find(o => o.value == _id);
            _cnaes.push({ tbCnaes_Id: _id, principal: true, codigo: opcao?.codigo });
        }
        setGerador({ ...gerador, cnaes: _cnaes });

        if (_id && errors.cnaePrincipal && setErrors) {
            const _errors = { ...errors };
            delete _errors.cnaePrincipal;
            setErrors(_errors);
        }
    }

    //Change dos CNAEs secundários
    const onChangeCnaesSecundarios = (selected) => {
        const _principal = (gerador.cnaes ?? []).filter(c => c.principal);
        const _principalId = _principal.length > 0 ? _principal[0].tbCnaes_Id : null;
        const _secundarios = (selected ?? [])
            .filter(o => o.value != _principalId)
            .map(o => ({ tbCnaes_Id: o.value, principal: false, codigo: o.codigo }));
        setGerador({ ...gerador, cnaes: [..._principal, ..._secundarios] });
    }
    const onBlur = () => {
        const cpfcnpj = gerador.cpfcnpj.replace(/[^a-zA-Z0-9]/g, '');
        if (cpfcnpj.length >= 11) {
            gerador_api.GetItemByCpfCnpj(cpfcnpj).then(response => {
                if (response.data) {
                    if (!session) {
                        showMessage("Aviso", "CNPJ já cadastrado no sistema", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                        return
                    }
                    response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
                    response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
                    response.data.tbSetores_Id = response.data.tbSetores_Id ? response.data.tbSetores_Id.toString() : null;
                    //campo só vai aparecer caso for se tiver integracaoCadastros
                    response.data.dataValidade = response.data.dataValidade ? moment(response.data.dataValidade).format("YYYY-MM-DD") : null;
                    
                    const pendenteAnalise = response.data.localidades.some(x => x.status === "Pendente");
                    if (pendenteAnalise) {
                        showMessage("Aviso", "Este gerador possui uma solicitação de cadastro pendente de análise. Efetue a análise do cadastro.", "error", null);
                    }
                    setGerador(response.data);
                } else {
                    if (integracaoCadastros) {
                        showMessage("Aviso", "Cadastro não localizado no sistema. O Gerador deve procurar a Secretaria para se cadastrar.", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                    } else if(disabledCampos) {
                        showMessage("Aviso", "Cadastro não localizado no sistema", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                        
                    }
                }
            })
        }
    }

    return (
        <div className='m-4 p-2 rounded-3 containerStep'>
            <Row className='mb-2'>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"18"}
                        id="cpfcnpj"
                        disabled={(session?.acesso?.modulo === "Transportador" && !gerador.id) ? false : !gerador.editFicha}
                        onBlur={onBlur}
                        label={"* CPF / CNPJ"}
                        invalid={errors.cpfcnpj ? true : false}
                        value={gerador.cpfcnpj}
                        onChange={onChangeGerador}
                        name="cpfcnpj"
                        mask={mascaras.cpfcnpjMask}
                    />
                    {errors.cpfcnpj && <span className={"form-control-label text-danger"}>{errors.cpfcnpj.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Fantasia"}
                        invalid={errors.fantasia ? true : false}
                        value={gerador.fantasia}
                        onChange={onChangeGerador}
                        name="fantasia"
                    />
                    {errors.fantasia && <span className={"form-control-label text-danger"}>{errors.fantasia.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Razão Social"}
                        invalid={errors.razao ? true : false}
                        value={gerador.razao}
                        onChange={onChangeGerador}
                        name="razao"
                    />
                    {errors.razao && <span className={"form-control-label text-danger"}>{errors.razao.message}</span>}
                </Col>
            </Row>
            <Row className='mb-2'>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Email"}
                        invalid={errors.email ? true : false}
                        value={gerador.email}
                        onChange={onChangeGerador}
                        name="email"
                    />
                    {errors.email && <span className={"form-control-label text-danger"}>{errors.email.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Responsável"}
                        invalid={errors.contato ? true : false}
                        value={gerador.contato}
                        onChange={onChangeGerador}
                        name="contato"
                    />
                    {errors.contato && <span className={"form-control-label text-danger"}>{errors.contato.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"14"}
                        mask={mascaras.celularMask}
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Fone"}
                        invalid={errors.fone ? true : false}
                        value={gerador.fone}
                        onChange={onChangeGerador}
                        name="fone"
                    />
                    {errors.fone && <span className={"form-control-label text-danger"}>{errors.fone.message}</span>}
                </Col>
            </Row>
            <Row className='mb-2'>
                <Col md={"12"} lg={integracaoCadastros ? "3" : "4"}>
                    <TextField
                        maxLength={"14"}
                        mask={mascaras.celularMask}
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"Celular"}
                        invalid={errors.celular ? true : false}
                        value={gerador.celular}
                        onChange={onChangeGerador}
                        name="celular"
                    />
                    {errors.celular && <span className={"form-control-label text-danger"}>{errors.celular.message}</span>}
                </Col>
                <Col md={"12"} lg={integracaoCadastros ? "3" : "4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Categoria"}
                        invalid={errors.categoria ? true : false}
                        type={"select"}
                        value={gerador.categoria}
                        onChange={onChangeGerador}
                        name="categoria"
                        options={categorias}
                    />
                    {errors.categoria && <span className={"form-control-label text-danger"}>{errors.categoria.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Ramo de atividade"}
                        invalid={errors.tbSegmentos_Id ? true : false}
                        type={"select"}
                        value={gerador.tbSegmentos_Id}
                        onChange={onChangeGerador}
                        name="tbSegmentos_Id"
                        options={ramosDeAtividade}
                    />
                    {errors.tbSegmentos_Id && <span className={"form-control-label text-danger"}>{errors.tbSegmentos_Id.message}</span>}
                </Col>
                {integracaoCadastros &&
                    <Col md={"12"} lg={"2"}>
                        <TextField
                            disabled={!gerador.editFicha || disabledCampos}
                            label={"Data Validade"}
                            type={"date"}
                            value={gerador.dataValidade}
                            onChange={onChangeGerador}
                            name="dataValidade"
                        />
                    </Col>
                }
            </Row>
            {setupVariavel?.informarCnaeCadastroGerador &&
                <Row className='mb-2'>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            disabled={!gerador.editFicha || disabledCampos}
                            label={"* CNAE principal"}
                            invalid={errors.cnaePrincipal ? true : false}
                            type={"select"}
                            value={cnaePrincipal?.tbCnaes_Id ?? ""}
                            onChange={onChangeCnaePrincipal}
                            name="cnaePrincipal"
                            options={[{ value: "", text: "Selecione" }, ...cnaesOptions]}
                        />
                        {errors.cnaePrincipal && <span className={"form-control-label text-danger"}>{errors.cnaePrincipal.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"8"}>
                        <TextField
                            disabled={!gerador.editFicha || disabledCampos}
                            label={"CNAEs secundários"}
                            type={"select"}
                            multiple
                            value={cnaesSecundarios}
                            onChange={onChangeCnaesSecundarios}
                            name="cnaesSecundarios"
                            options={cnaesOptions.filter(o => o.value != cnaePrincipal?.tbCnaes_Id)}
                        />
                    </Col>
                </Row>
            }
            {!!gerador.id && session?.acesso?.sigla === "GS" &&
                <Row className='mb-2'>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            disabled={!gerador.editFicha || disabledCampos}
                            label={"Status"}
                            invalid={errors.status ? true : false}
                            type={"select"}
                            value={gerador.status}
                            onChange={onChangeGerador}
                            name="status"
                            options={statusOptions}
                        />
                        {errors.status && <span className={"form-control-label text-danger"}>{errors.status.message}</span>}
                    </Col>
                </Row>
            }
        </div>
    );
}
